import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/content`;

// Achievements
export const getAchievements = async () => {
  try {
    const response = await axios.get(`${API}/achievements`);
    return response.data;
  } catch (error) {
    console.error('Error fetching achievements:', error);
    return [];
  }
};

// Certifications
export const getCertifications = async () => {
  try {
    const response = await axios.get(`${API}/certifications`);
    return response.data;
  } catch (error) {
    console.error('Error fetching certifications:', error);
    return [];
  }
};

// Memberships
export const getMemberships = async () => {
  try {
    const response = await axios.get(`${API}/memberships`);
    return response.data;
  } catch (error) {
    console.error('Error fetching memberships:', error);
    return [];
  }
};

// Testimonials
export const getTestimonials = async () => {
  try {
    const response = await axios.get(`${API}/testimonials`);
    return response.data;
  } catch (error) {
    console.error('Error fetching testimonials:', error);
    return [];
  }
};

// Experience
export const getExperience = async () => {
  try {
    const response = await axios.get(`${API}/experience`);
    return response.data;
  } catch (error) {
    console.error('Error fetching experience:', error);
    return [];
  }
};

// Case Studies
export const getCaseStudies = async () => {
  try {
    const response = await axios.get(`${API}/case-studies`);
    return response.data;
  } catch (error) {
    console.error('Error fetching case studies:', error);
    return [];
  }
};

// Services
export const getServices = async () => {
  try {
    const response = await axios.get(`${API}/services`);
    return response.data;
  } catch (error) {
    console.error('Error fetching services:', error);
    return [];
  }
};

// Industries
export const getIndustries = async () => {
  try {
    const response = await axios.get(`${API}/industries`);
    return response.data;
  } catch (error) {
    console.error('Error fetching industries:', error);
    return [];
  }
};

// Key Metrics
export const getKeyMetrics = async () => {
  try {
    const response = await axios.get(`${API}/key-metrics`);
    return response.data;
  } catch (error) {
    console.error('Error fetching key metrics:', error);
    return [];
  }
};

// Personal Info
export const getPersonalInfo = async () => {
  try {
    const response = await axios.get(`${API}/personal-info`);
    return response.data;
  } catch (error) {
    console.error('Error fetching personal info:', error);
    return null;
  }
};
